var staticParseInt = parseInt

module.exports = staticParseInt



//////////////////
// WEBPACK FOOTER
// ./node_modules/xe-utils/staticParseInt.js
// module id = tgZ/
// module chunks = 17